export default __webpack_public_path__ + "static/media/addNew.71e014d7.svg";